import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

const WorkflowHostModal = ({ isOpen, onRequestClose, onSelect,server }) => {
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedHost, setSelectedHost] = useState(null);

  useEffect(() => {
    if (isOpen) {
      // Simulando la llamada al API para obtener datos de hosts
      const fetchData = async () => {
        try {
          const response = await fetch(server.url +
            "/api/v1/cassia/hosts/");
          const data = await response.json();

          // Formatear los datos
          const formattedData = data.map((item) => ({
            id: String(item.hostid), // Convertimos a string para evitar problemas de comparación
            name: item.hostname
          }));
          setDropdownData(formattedData);
        } catch (error) {
          console.error('Error fetching hosts:', error);
        }
      };

      fetchData();
    }
  }, [isOpen]);

  const handleSelectChange = (e) => {
    const selectedId = e.target.value;

    // Buscar la opción seleccionada en los datos del dropdown
    const selectedOption = dropdownData.find((option) => option.id === selectedId);

    if (selectedOption) {
      setSelectedHost(selectedOption);
    } else {}
  };

  const handleConfirm = () => {
    if (selectedHost) {
      onSelect(selectedHost); // Devolver el host seleccionado al componente padre
      onRequestClose(); // Cerrar el modal después de seleccionar
    } else {}
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          padding: '20px',
          borderRadius: '10px',
        }
      }}
    >
      <h2>Selecciona un Host</h2>
      {dropdownData.length > 0 ? (
        <select onChange={handleSelectChange} value={selectedHost?.id || ''}>
          <option value="" disabled>Seleccione una opción</option>
          {dropdownData.map((option) => (
            <option key={option.id} value={option.id}>{option.name}</option>
          ))}
        </select>
      ) : (
        <p>Cargando opciones...</p>
      )}
      <button onClick={handleConfirm} style={{ marginTop: '10px', padding: '8px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>Confirmar</button>
      <button onClick={onRequestClose} style={{ marginTop: '10px', marginLeft: '10px', padding: '8px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px' }}>Cancelar</button>
    </Modal>
  );
};

export default WorkflowHostModal;
